import React, { useEffect, useState } from "react";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import StatusComp from "../../../components/StatusComp";
import SelectBox from "../../../components/SelectBox";
import { post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import ConsolidatedReport from "./ConsolidatedReport";
import toast from "react-hot-toast";
import CommonDatePickerReports from "../../../components/CommonDatePickerReports";

const SiteReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [cameraList, setCameraList] = useState([]);
  const [camTypes, setCamTypes] = useState([]);
  const [selecetdCam, setSelectedCam] = useState(null);

  const [siteData, setSiteData] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [reportData, setReportData] = useState({});

  const type = location?.state?.type;

  const data = location.state?.data;

  const createdAt = moment().format("DD-MM-YYYY");
  const [comapanyList, setCompanyList] = useState([]);
  const [siteList, setSiteList] = useState([]);

  const getCompanyList = () => {
    post(URL.COMPANY_LIST_ADMIN, {})
      .then((res) => {
        setCompanyList(res?.companies);
        setSiteList([]);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company_id) => {
    let formdata = new FormData();
    setSelectedCompany(company_id);
    setReportData({});
    setSelectedOption([]);
    formdata.append("company_id", company_id?.value);
    post(URL.ACTIVE_ADMIN_SITE, formdata)
      .then((res) => {
        setSelectedOption([]);
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        } else {
          setSiteList([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  const handlePreview = () => {
    if (!selectedCompany?.value) {
      toast.error("Please Select Company");
      return;
    }

    if (!selectedOption?.value) {
      toast.error("Please Select Site");
      return;
    }

    if (!fromDate) {
      toast.error("Please Select From Date");
      return;
    }

    if (!toDate) {
      toast.error("Please Select To Date");
      return;
    }

    let formdata = new FormData();
    formdata.append("from_date", moment(fromDate).format("YYYY-MM-DD"));
    formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    formdata.append("site_id", selectedOption?.value);

    if (selecetdCam?.value) {
      formdata.append("camera_id", selecetdCam?.value);
    }
    post(URL.GET_CONSOLIDATED_REPORT_ADMIN, formdata)
      .then((res) => {
        if (res?.data) {
          setReportData(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getCameraList = (site_id) => {
    let formdata = new FormData();
    formdata.append("site_id", site_id?.value);
    post(URL.CAMERA_LISTS_ADMIN, formdata)
      .then((res) => {
        if (res?.cameras?.length > 0) {
          let temp = [];
          res?.cameras?.map((item, ind) => {
            let obj_ = {
              ...item,
              name_old: item?.name,
              name: `${item?.code} - ${item?.name}`,
            };
            temp.push(obj_);
          });
          setCameraList(temp);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"Consolidated"} type={"Report"} hide={!type} />

      {type && (
        <div className="d-flex p-1">
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Company Name & Code
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={`${data?.companyName ?? "Ninos"} - ${
                  data?.companyId ?? "N001"
                }`}
              />
            </div>

            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Name & Code
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={`${data?.siteName ?? "Robotics"} - ${
                  data?.siteCode ?? "R001"
                }`}
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Location
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={data?.siteLocation ?? "Chennai,vadapalani"}
              />
            </div>
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Admin
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={data?.siteAdminName ?? "Shakthivel"}
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Admin Created On
              </p>
              <input className="input-box w-100" readOnly value={createdAt} />
            </div>
          </div>
        </div>
      )}

      {type && (
        <div className="col-md-12 p-3 d-flex ac-js gap-5">
          <div className="p-2 mb-2">
            <button className="submit-btn">View Report</button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-notifications", {
                  state: {
                    data: data,
                    type: "site-view",
                  },
                })
              }
            >
              View Notifications
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-slot-main", {
                  state: { type: "site-view", data: data, superAdmin: true },
                })
              }
            >
              View slot days
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-alert-types", {
                  state: {
                    type: "site-view",
                    data: data,
                  },
                })
              }
            >
              Alert Types
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-cameras", {
                  state: {
                    type: "site-view",
                    data: data,
                  },
                })
              }
            >
              Cameras
            </button>
          </div>
        </div>
      )}

      <div className={`d-flex ${type ? "gap-5" : "ac-jb"}`}>
        {/* Company Select */}
        {!type && (
          <div className="col-md-2">
            <label className="form-label">Select Company*</label>
            <SelectBox
              arrayData={comapanyList}
              data={company}
              setData={setCompany}
              selectedOption={selectedCompany}
              setSelectedOption={getSiteList}
              style={true}
            />
          </div>
        )}

        {/* Site Select */}
        {!type && (
          <div className="col-md-2">
            <label className="form-label">Select Site*</label>
            <SelectBox
              arrayData={siteList}
              data={siteData}
              setData={setSiteData}
              selectedOption={selectedOption}
              setSelectedOption={(val) => {
                setSelectedOption(val);
                getCameraList(val);
                setReportData({});
              }}
              disabled={selectedCompany?.label ? false : true}
              style={true}
            />
          </div>
        )}

        <CommonDatePickerReports
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={(even) => {
            setFromDate(even);
            setReportData({});
          }}
          setToDate={(even) => {
            setToDate(even);
            setReportData({});
          }}
        />

        {/* Preview Button */}
      </div>
      <div className={`d-flex col-md-12 mt-3 gap-5 ac-js`}>
        <div className="col-md-2">
          <label className="form-label">Select Camera</label>
          <SelectBox
            arrayData={cameraList}
            data={camTypes}
            setData={setCamTypes}
            selectedOption={selecetdCam}
            setSelectedOption={(even) => {
              setSelectedCam(even);
              setReportData({});
            }}
            style={true}
          />
        </div>

        <div className="col-md-1 mt-4">
          <button onClick={handlePreview} className="submit-btn">
            Preview
          </button>
        </div>
      </div>

      {/* second section */}

      {/* download btn */}
      {reportData?.company && <ConsolidatedReport data={reportData} />}
    </div>
  );
};

export default SiteReport;
